import { useLanguage } from "@/contexts/LanguageContext";

/**
 * Inline bilingual text component.
 * Usage: <T de="Projekt anfragen" it="Richiedi un progetto" />
 */
export function T({ de, it }) {
  const { lang } = useLanguage();
  return <>{lang === "it" ? it : de}</>;
}

/**
 * Hook for bilingual text selection.
 * Usage: const { t } = useT();  t("Projekt anfragen", "Richiedi un progetto")
 */
export function useT() {
  const { lang } = useLanguage();
  const t = (de, it) => lang === "it" ? it : de;
  return { t, lang };
}
